import { render, staticRenderFns } from "./modelDetail.vue?vue&type=template&id=9095f008&scoped=true"
import script from "./modelDetail.vue?vue&type=script&lang=js"
export * from "./modelDetail.vue?vue&type=script&lang=js"
import style0 from "./modelDetail.vue?vue&type=style&index=0&id=9095f008&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9095f008",
  null
  
)

export default component.exports